import { Form, Formik } from 'formik';
import React, { useContext } from 'react';
import * as Yup from 'yup';

import { emailSchema, stringSchema } from '../../../../../services/schemas';
import { pseFields } from '../../../../../store/catalogs/forms/PSE';
import Context from '../../../../../store/context';
import Button from '../../../../Buttons/Button/Button';
import LabelFieldFormik from '../../../../Fields/LabelField/LabelFieldFormik';
import FormGrid from '../../../FormGrid/FormGrid';

import classes from './AddPSEAccount.module.scss';

const valuesFormik = {
  name: '',
  typeOfPerson: '',
  identificationType: '',
  identificationNumber: '',
  email: '',
  phone: '',
  phoneIndicative: '+57',
  country: '',
  address: ''
};
const messageFormik = 'Campo obligatorio';
const validationSchema = Yup.object().shape({
  name: stringSchema(messageFormik),
  typeOfPerson: stringSchema(messageFormik),
  identificationType: stringSchema(messageFormik),
  identificationNumber: stringSchema(messageFormik),
  email: emailSchema(messageFormik),
  phone: stringSchema(messageFormik),
  phoneIndicative: stringSchema(messageFormik),
  country: stringSchema(messageFormik),
  address: stringSchema(messageFormik)
});

const AddPSEAccount = ({ onAccept, pseBanks }) => {
  const {
    modal: { hideModal }
  } = useContext(Context);

  const fieldsState = [
    { ...pseFields.moviiBankCode, options: pseBanks },
    pseFields.name,
    pseFields.typeOfPerson,
    pseFields.identificationType,
    pseFields.identificationNumber,
    pseFields.email,
    pseFields.phone,
    pseFields.country,
    pseFields.address
  ];

  const setField = (key, value, setFieldValue) => {
    if (key === 'typeOfPerson') {
      if (value === '1') {
        setFieldValue('identificationType', '31');
      } else {
        setFieldValue('identificationType', '');
      }
    }
    setFieldValue(key, value);
  };

  return (
    <div>
      <Formik initialValues={valuesFormik} validationSchema={validationSchema} onSubmit={onAccept}>
        {({ setFieldValue, errors }) => (
          <Form>
            <FormGrid
              isSubtitle={true}
              subtitle='Agregar cuenta PSE'
              onChange={(key, value) => setField(key, value, setFieldValue)}
              fields={fieldsState}
              Render={LabelFieldFormik}
            />
            <div className={classes.buttons}>
              <Button custom='secondary' onClick={hideModal}>
                Volver
              </Button>
              <Button type='submit'>Continuar</Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddPSEAccount;
